/**
 * 玩家数据同步工具
 * 统一处理玩家数据在场景和 gameState 之间的同步，避免重复代码
 */

/**
 * 深拷贝对象
 * @param {*} obj - 要拷贝的对象
 * @returns {*} 深拷贝后的对象
 */
export function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    return JSON.parse(JSON.stringify(obj));
}

/**
 * 同步玩家属性从场景玩家到 gameState
 * @param {Object} scenePlayer - 场景中的玩家对象
 * @param {Object} gameStatePlayer - gameState 中的玩家对象
 * @param {Object} options - 选项 { includeVehicle: boolean, includePosition: boolean, position: {x, y}, tilePosition: {tileX, tileY} }
 */
export function syncPlayerToGameState(scenePlayer, gameStatePlayer, options = {}) {
    if (!scenePlayer || !gameStatePlayer) {
        return;
    }

    const {
        includeVehicle = true,
        includePosition = false,
        position = null,
        tilePosition = null,
        inVehicle = null
    } = options;

    // 同步基础属性
    const playerProperties = [
        'hp', 'maxHp', 'attack', 'defense', 'money', 'exp', 
        'level', 'nextLevelExp', 'inventory', 'equipment', 'skills'
    ];

    playerProperties.forEach(prop => {
        if (scenePlayer[prop] !== undefined) {
            gameStatePlayer[prop] = scenePlayer[prop];
        }
    });

    // 同步战车数据（深拷贝）
    if (includeVehicle && scenePlayer.vehicle) {
        gameStatePlayer.vehicle = deepClone(scenePlayer.vehicle);
    }

    // 同步位置信息
    if (includePosition) {
        if (position) {
            gameStatePlayer.x = position.x;
            gameStatePlayer.y = position.y;
        }
        if (tilePosition) {
            gameStatePlayer.tileX = tilePosition.tileX;
            gameStatePlayer.tileY = tilePosition.tileY;
        }
        if (inVehicle !== null) {
            gameStatePlayer.inVehicle = inVehicle;
        }
    }
}


